import type { ClockPayload } from '../schema';
import loc from 'owa-localize';
import {
    clockSearchStringNoTimeZones,
    clockSearchStringTwoTimeZones,
    clockSearchStringTwoPlusTimeZones,
} from '../clockStrings.locstring.json';

export default function getLocalizedTitleAndSearchString({ timeZones }: ClockPayload) {
    switch (timeZones.length) {
        case 0:
            return loc(clockSearchStringNoTimeZones);
        case 1:
            return timeZones[0].city;
        case 2:
            return loc(clockSearchStringTwoTimeZones, timeZones[0].city, timeZones[1].city);
        default:
            return loc(
                clockSearchStringTwoPlusTimeZones,
                timeZones[0].city,
                timeZones[1].city,
                timeZones.length - 2
            );
    }
}
